import { PortalSidebar, PORTAL_SIDEBAR_ASIDE_CLS } from "@/components/admin/PortalSidebar";
import { useUnreadCount } from "@/lib/portal-cliente/notification-data";
import { usePortalNavItems, isNavItemActive } from "@/lib/portal-cliente/portal-nav-data";
import { useLocation, useNavigate } from "react-router-dom";

interface SidebarProps {
  appVersion?: string;
  showBackToAdmin?: boolean;
  onBackToAdmin?: () => void;
  onSignOut?: () => void;
  displayName?: string;
  userRole?: string;
  isClient?: boolean;
  onAfterNavigate?: () => void;
}

export const SidebarContent = ({
  appVersion,
  showBackToAdmin,
  onBackToAdmin,
  onSignOut,
  displayName = "Usuario",
  userRole = "Cliente",
  isClient = true,
  onAfterNavigate,
}: SidebarProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const totalUnread = useUnreadCount();
  const { data: items = [] } = usePortalNavItems();

  return (
    <PortalSidebar
      portal="Portal del cliente"
      groups={[{
        items: items.map((item) => {
          const isNotif = item.route.includes("notificaciones");
          return {
            key: String(item.id),
            label: item.label,
            icon: item.icon,
            active: isNavItemActive(item.route, location.pathname),
            onSelect: () => { navigate(item.route); onAfterNavigate?.(); },
            badge: isNotif && totalUnread > 0 ? (
              <span className="flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-bold text-destructive-foreground">
                {totalUnread > 9 ? "9+" : totalUnread}
              </span>
            ) : undefined,
          };
        }),
      }]}
      usuario={{
        nombre: displayName,
        rol: userRole,
        onClick: () => { navigate("/admin/portal-cliente/perfil"); onAfterNavigate?.(); },
      }}
      onRegresar={!isClient && showBackToAdmin ? onBackToAdmin : undefined}
      onCerrarSesion={() => onSignOut?.()}
    />
  );
};

const Sidebar = (props: SidebarProps) => (
  <aside className={PORTAL_SIDEBAR_ASIDE_CLS}>
    <SidebarContent {...props} />
  </aside>
);

export default Sidebar;
